import React, { useState } from "react";
import { themes } from "services/constants";
import * as Mui from "@mui/material";
import { GlobalDialogBox } from "components/GlobalDialogBox";
import { Products } from "./Products";
import { Features } from "./Features";
import { CustomButton } from "components/CustomComponents";
import { rowEndStyle } from "services/constants/Styles";

export const SupportAdmin = () => {
  const [selectedComponent, setSelectedComponent] = useState("Products");
  const [modifiedData, setModifiedData] = useState(false);
  const [openDialogBox, setOpenDialogBox] = useState(false);
  const [clickedScreen, setClickedScreen] = useState("");


  return (
    <React.Fragment>
      <Mui.Grid container sx={{ paddingTop: 2 }}>
        <Mui.Box
          sx={{
            display: "flex",
            alignItems: "center",
            borderRadius: 3,
            height: 45,
            width: 250,
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Mui.ToggleButtonGroup
            value={selectedComponent}
            exclusive
            sx={{
              display: "flex",
              width: "100%",
              height: "100%",
              position: "absolute",
              borderRadius: 3,
              backgroundColor: themes.lightBrown,
            }}
          >
            <Mui.ToggleButton
              value="Products"
              sx={{
                flex: 1,
                textTransform: "capitalize",
                fontSize: 18,
                fontWeight: 600,
                border: "none",
                color:
                  selectedComponent === "Products"
                    ? themes.whiteColor
                    : themes.headLine,
                backgroundColor:
                  selectedComponent === "Products"
                    ? themes.headLine
                    : themes.lightBrown,
                "&.Mui-selected": {
                  backgroundColor: themes.headLine,
                  color: themes.whiteColor,
                  "&:hover": {
                    backgroundColor: themes.headLine,
                    color: themes.whiteColor,
                  },
                },
                "&:hover": {
                  backgroundColor:
                    selectedComponent === "Products"
                      ? themes.headLine
                      : themes.lightBrown,
                  color:
                    selectedComponent === "Products"
                      ? themes.whiteColor
                      : themes.headLine,
                },
              }}
              onClick={() => {
                if (modifiedData) {
                  setClickedScreen("Products");
                  setOpenDialogBox(true);
                } else {
                  setSelectedComponent("Products");
                }
              }}
            >
              <Mui.Typography style={{ fontWeight: "bold", fontSize: 15 }}>
                Products
              </Mui.Typography>
            </Mui.ToggleButton>
            <Mui.ToggleButton
              value="Features"
              sx={{
                width: "200px",
                flex: 1,
                textTransform: "capitalize",
                fontSize: 18,
                fontWeight: 600,
                border: "none",
                color:
                  selectedComponent === "Features"
                    ? themes.whiteColor
                    : themes.headLine,
                backgroundColor:
                  selectedComponent === "Features"
                    ? themes.headLine
                    : themes.lightBrown,
                "&.Mui-selected": {
                  backgroundColor: themes.headLine,
                  color: themes.whiteColor,
                  "&:hover": {
                    backgroundColor: themes.headLine,
                    color: themes.whiteColor,
                  },
                },
                "&:hover": {
                  backgroundColor:
                    selectedComponent === "Features"
                      ? themes.headLine
                      : themes.lightBrown,
                  color:
                    selectedComponent === "Features"
                      ? themes.whiteColor
                      : themes.headLine,
                },
              }}
              onClick={() => {
                if (modifiedData) {
                  setClickedScreen("Features");
                  setOpenDialogBox(true);
                } else {
                  setSelectedComponent("Features");
                }
              }}
            >
              <Mui.Typography style={{ fontWeight: "bold", fontSize: 15 }}>
                Features
              </Mui.Typography>
            </Mui.ToggleButton>
          </Mui.ToggleButtonGroup>
        </Mui.Box>
      </Mui.Grid>
      {selectedComponent === "Products" ? (
        <Products
          setModifiedData={setModifiedData}
          modifiedData={modifiedData}
        />
      ) : (
        <Features
          setModifiedData={setModifiedData}
          modifiedData={modifiedData}
        />
      )}

      <GlobalDialogBox
        open={openDialogBox}
        handleCloseDialog={() => {
          setOpenDialogBox(false);
        }}
        title="Warning"
        minWidth={550}
      >
        <Mui.Grid container>
          <Mui.Typography sx={{ paddingLeft:1,fontSize:20, fontWeight: "bold" }}>
            Make sure the user can move to the {clickedScreen} screen without
            clicking the Save button
          </Mui.Typography>
          <Mui.Grid container sx={{ ...rowEndStyle }}>
            <CustomButton
              actionFuntion={() => {
                setOpenDialogBox(false);
              }}
              actionName="Cancel"
              typeName="button"
            />
            &nbsp;
            <CustomButton
              actionFuntion={() => {
                setSelectedComponent(clickedScreen);
                setModifiedData(false);
                setOpenDialogBox(false);
              }}
              actionName="Ok"
              typeName="button"
            />{" "}
          </Mui.Grid>
        </Mui.Grid>
      </GlobalDialogBox>
    </React.Fragment>
  );
};
